var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartSuccess(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.413,
    height: 141.83,
    viewBox: "0 0 160.413 141.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M135.749,14.211a38.261,38.261,0,0,0-54.122,0l-7.374,7.374L66.88,14.211A38.27,38.27,0,0,0,12.758,68.333l7.374,7.374,54.122,54.122,54.122-54.122,7.374-7.374a38.261,38.261,0,0,0,0-54.122Z",
    transform: "translate(5.951 4.502)",
    fill: "none",
    stroke: "#f3bd1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSuccess);
export default __webpack_public_path__ + "static/media/heart-success.29111dd08864fc4ed5e609cff3ad240b.svg";
export { ForwardRef as ReactComponent };